import styled from 'styled-components';
import FontAwesome from 'react-fontawesome';

export const Wrapper = styled.div`
	width: 100%;
	display: ${props => props.mobile ? 'unset' : 'flex'};
	align-items: center;
`;

export const Icon = styled(FontAwesome)`
	font-size: ${props => props.mobile ? '45px' : '35px'} !important;
	min-width: 55px;
	padding-right: ${props => props.mobile ? '0px' : '20px'};
	padding-left: ${props => props.mobile ? '10px' : 'unset'};
`;

export const Title = styled.h4`
	font-size: 25px;
	font-weight: 300;
	width: ${props => props.mobile ? '100%' : '10%'};
	min-width: 175px;
	text-align: ${props => props.mobile ? 'center' : 'unset'};
`;

export const Content = styled.p`
	font-size: 20px;
	padding-right: ${props => props.mobile ? '20px' : '10%'};
	text-align: ${props => props.mobile ? 'center' : 'unset'};
`;


// WEBPACK FOOTER //
// ./src/components/service/components.js